import { all, call, takeLatest, put } from "redux-saga/effects";
import { normalize, schema } from "normalizr";
import { getErrorMessage } from "../../../utils/sagasErrorHandler";
import { LOGIN_URL } from "../../../config";
import {
    getShortUrl,
    getShortUrlError,
    getShortUrlSuccess,
    logOut,
    mergeAppState,
    mergeShortUrl,
    setAuthPolicy,
    storeShortUrl
} from "./actions";
import {
    getAuthPolicyRequest,
    getShortUrlRequest,
    getUserRequest,
    logOutRequest,
    storeShortUrlRequest
} from "./api";
import {copyStringToClipboard} from "utils/helpers/copyStringToClipboard";

const definitionsSchema = new schema.Entity("auth_policy_definitions" , {},{ idAttribute: "code" });
const definitionsListSchema = new schema.Array(definitionsSchema);

export function* initApp() {
    try {
        yield put(mergeAppState({ isLoading: true }));

        const { auth_policy_definitions, role } = yield call(getAuthPolicyRequest);
        const { result, entities } = normalize(auth_policy_definitions, definitionsListSchema);

        const user = yield call(getUserRequest);

        yield put(setAuthPolicy({
            role,
            user,
            authPolicyCodes: result,
            authPolicyDefinitions: entities.auth_policy_definitions
        }));
    } catch (error) {
        yield put(mergeAppState({ isLoading: false }));
        getErrorMessage(error);
    }
}

export function* logOutWorker() {
    try {
        yield call(logOutRequest);

        window.location.href = LOGIN_URL();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleStoreShortUrl ({ payload }) {
    try {
        const response = yield call(storeShortUrlRequest, {id: payload.id, body: payload.body});
        if (payload.path) {
            copyStringToClipboard(`${payload.path}?sid=${response.id}`);
        }
        yield put(mergeShortUrl({ id: response.id, body: payload.body }));
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleGetShortUrl ({ payload }) {
    try {
        const response = yield call(getShortUrlRequest, payload);
        yield put(getShortUrlSuccess({
            id: payload,
            body: response.body
        }));
    } catch (error) {
        yield put(getShortUrlError());
        getErrorMessage(error);
    }
}

// Watchers
export function* appSaga() {
    yield all([
        yield call(initApp),
        yield takeLatest(logOut, logOutWorker),
        yield takeLatest(storeShortUrl, handleStoreShortUrl),
        yield takeLatest(getShortUrl, handleGetShortUrl)
    ]);
}
